import { render, staticRenderFns } from "./RevisionPage.vue?vue&type=template&id=14333be1&scoped=true&"
import script from "./RevisionPage.vue?vue&type=script&lang=js&"
export * from "./RevisionPage.vue?vue&type=script&lang=js&"
import style0 from "./RevisionPage.vue?vue&type=style&index=0&id=14333be1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14333be1",
  null
  
)

export default component.exports